<template>
  <div class="vch-myaccount-dashboard-header">
   
   
     <div class="vch-grid">
      <div class="vch-col-12 vch-col-md-3 vch-top-order">
    
        <div class='vch-myaccount-dashboard-header__content'>
          <h3 class='vch-myaccount-dashboard-header__welcometitle heading-xl'>{{welcomeLine}}</h3>
          <h1 class='vch-myaccount-dashboard-header__title heading-xl'>{{headLine}}</h1>
          <p class='heading-sm'>{{dateOfJoining}}</p>
        </div>
     </div> 
     <div class="vch-col-12 vch-col-md-8 vch-bottom-order">
      <div class='dashboard__image'>
        <img class="dashboard__image lazyload" :src="headerImage" :alt="headerImageAlt">
      </div>
    
    
  </div>
  </div>
     
  </div>
</template>

<script>
export default {
  name: 'vch-myaccount-dashboard-header',
  props: {
    headLine: {
      type: String,
      required: true,
    },
    welcomeLine: {
      type: String,
      required: true,
    },
    dateOfJoining: {
      type: String,
      required: true,
    },
    headerImage: {
      type: String,
      required: true,
    },
    headerImageAlt: {
      type: String,
      default: 'Dashboard Banner Image',
    }    
  },

  data() {
    return {
      nameHeadline: this.headLine,
      joningDate: this.dateOfJoining,
      dashboardwelcomeLine:this.welcomeLine,
    };
  },

};
</script>

<style lang="scss" src="./myaccount-dashboard-header.scss"></style>
